import type { ReactNode, Ref } from 'react';

interface CalculatorShellProps {
  title: string;
  disclaimer: string;
  /** Announced on change; keep result detail too long to hear out of it. */
  summary?: ReactNode;
  /** Focus target after a calculation. */
  summaryRef?: Ref<HTMLDivElement>;
  children: ReactNode;
}

export const CalculatorShell = ({ title, disclaimer, summary, summaryRef, children }: CalculatorShellProps) => (
  <div className="rounded-xl bg-bg-raised-secondary p-6 font-sans sm:p-10">
    {/* The page provides the h1. */}
    <h2 className="mb-6 text-heading-md">{title}</h2>

    <div role="status" ref={summaryRef} tabIndex={-1}>
      {summary}
    </div>

    {children}

    <p className="mt-8 text-legal">{disclaimer}</p>
  </div>
);
